<template>
  <div class="p-inform-container right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: tabActive == index }"
          @click="onSelectTab(index)"
          >{{ item.title }}</a
        >
      </div>
      <!-- <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          作业消息：<span class="num">{{ workTotal }}</span>
        </div>
        <div class="right-header-text">
          系统消息：<span class="num">{{ systemTotal }}</span>
        </div>
      </div> -->
    </div>
    <!-- 班级列表 -->
    <template v-if="tabActive === 0">
      <div class="right-main  right-main-list" v-if="isNull">
        <div class="list-box">
          <div
            class="item flex-between"
            v-for="(item, index) in listData"
            :key="index"
          >
            <div class="item-left flex-row-start ">
              <div class="user-top">
                <img :src="item.teacher_img" alt="" class="user-top-img" />
              </div>
              <div class="item-l">
                <div class="item-l-top flex-between">
                  <span class="fs-18  fw">{{ item.title }}</span>
                  <span class="item-time fs-14">{{ item.create_date }}</span>
                </div>
                <div class="item-l-bottom flex-between">
                  <span class="em"
                    ><span class="c-40b8ee"
                      >班级码：{{ item.class_code }}</span
                    ></span
                  >
                  <span class="em"
                    >班主任：<span class="c-40b8ee">{{
                      item.teacher_name
                    }}</span></span
                  >
                  <span class="em"
                    >题目数量：<span class="c-40b8ee">{{
                      item.question_count
                    }}</span></span
                  >
                  <span class="em"
                    >涉及知识点：<span class="c-40b8ee">{{
                      item.knowledge_count
                    }}</span></span
                  >
                </div>
              </div>
            </div>
            <div class="item-right flex-between">
              <div>
                <div class="mb5">
                  <span class="item-right-text"
                    >孩子已读：
                    <span class="c-bc4654" v-if="item.is_read == 0">否</span>
                    <span class="c-40b8ee" v-else>是</span>
                  </span>
                  <el-button
                    type="danger"
                    class="item-right-button"
                    :disabled="item.is_head == 1"
                    >刷新</el-button
                  >
                </div>
                <div>
                  <span class="item-right-text"
                    >孩子已交：
                    <span class="c-bc4654" v-if="item.is_head == 0">否</span>
                    <span class="c-40b8ee" v-else>是</span></span
                  >
                  <el-button
                    type="primary"
                    class="item-right-button"
                    :disabled="item.is_head == 0"
                    @click="onLearningInfo(item)"
                    >查学情</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="onPageChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="right-main  right-main-list column" v-else>
        <img src="../../assets/images/list_null.png" alt="" srcset="" />
        <div class="null">暂无数据~~</div>
      </div>
    </template>
    <template v-if="tabActive === 1">
      <div class="right-main  right-main-list" v-if="isNull">
        <div class="list-box">
          <div
            class="item flex-between"
            v-for="(item, index) in systemList"
            :key="index"
          >
            <div class="item-left flex-row-start ">
              <div class="item-l">
                <div class="item-l-top">
                  <span class="fs-18  fw">{{ item.title }}</span>
                </div>
                <div class="item-l-bottom">
                  <span class="em"
                    >通知时间：<span class="c-40b8ee">{{
                      item.create_date
                    }}</span></span
                  >
                </div>
              </div>
            </div>
            <div class="item-right ">
              <div>
                <el-button type="danger" @click="onInfo(item)"
                  >展开详情</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="systemQuery.page"
            :page-size="systemQuery.pageSize"
            :total="systemTotal"
            @current-change="systemPageChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="right-main  right-main-list column" v-else>
        <img src="../../assets/images/list_null.png" alt="" srcset="" />
        <div class="null">暂无数据~~</div>
      </div>
    </template>
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.status"
      width="50%"
      center
    >
      <div class="dialog-head flex-row">
        <div>发布机构</div>
        <div>发布时间：2021/05/05 12:13</div>
      </div>
      <div class="dialog-content">
        学生批量修改
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-padding books-dialog"
      :title="dialogInform.title"
      :visible.sync="dialogInform.status"
      width="860px"
    >
      <!-- <div class="dialog-header flex-between">
        <div class="dialog-header-item active">成绩一览</div>
        <div class="dialog-header-item" @click="onAnswerQuestions(homeworkIng)">
          逐题分析
        </div>
      </div> -->
      <div class="dialog-content ">
        <div class="dialog-info">
          <div class="d-head flex-between">
            <div class="d-head-item">
              <div class="d-head-box">
                <div class="d-head-title">孩子的成绩</div>
                <div class="d-head-score">
                  <div>
                    <div class="d-head-score-item ">
                      总题数：{{ homeworkIng.question_count }}道
                    </div>
                    <!-- <div class="d-head-score-item ">满分：100分</div> -->
                  </div>
                  <div class="score-num" v-if="homeworkInfo.length>0">
                    {{ homeworkInfo[0].correct_accuracy }}%
                  </div>
                  <div class="score-text">我的得分率</div>
                </div>
              </div>
            </div>
            <div class="d-head-item dashed">
              <div class="d-head-box">
                <div class="d-head-title">知识点分析</div>
                <div>
                  <div>作业涉及知识点：{{ workKnowledgeCount }}</div>
                  <GeminiScrollbar class="d-head-k">
                    <span
                      class="item"
                      v-for="(w, k) in workKnowledgeList"
                      :key="k"
                      >{{ w }}</span
                    >
                  </GeminiScrollbar>
                </div>
              </div>
            </div>
            <div class="d-head-item">
              <div class="d-head-box">
                <div class="d-head-title">作答用时统计</div>
                <div>
                  <div class="mb10">
                    推荐作业用时：<span class="c-40b8ee">{{
                      homeworkIng.recommended_time
                    }}</span
                    >分钟
                  </div>
                  <div class="mt10">
                    你的累计用时：<span class="c-40b8ee">{{
                      homeworkIng.time
                    }}</span>
                  </div>
                  <div class="mt10">
                    用时评价：<span class="c-40b8ee">{{
                      homeworkIng.quiz_time_evaluation
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-center">
            <div class="d-head-title">作业得分详情</div>
            <div class="work-info-table flex-between">
              <div>
                <template>
                  <el-table :data="homeworkInfo" border>
                    <el-table-column prop="name" label="作业名称" width="180px">
                      <template slot-scope="scope"
                        ><div class="homework-info-name">
                          {{ scope.row.name }}
                        </div></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="correct_accuracy"
                      label="我的得分率"
                      width="100px"
                    >
                      <template slot-scope="scope"
                        ><span
                          >{{ scope.row.correct_accuracy }}%</span
                        ></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="avg_num"
                      label="班级平均得分率"
                      width="120px"
                    >
                      <template slot-scope="scope"
                        ><span>{{ scope.row.avg_num }}%</span></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="max_num"
                      label="班级最高得分率"
                      width="120px"
                    >
                      <template slot-scope="scope"
                        ><span>{{ scope.row.max_num }}%</span></template
                      >
                    </el-table-column>
                  </el-table>
                </template>
              </div>
              <div>
                <template>
                  <el-table :data="homeworkInfo" border>
                    <el-table-column
                      prop="num"
                      label="作业表现"
                      width="120px"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-rate
                          :value="scope.row.score"
                          disabled
                          :max="3"
                          :colors="colors"
                        >
                        </el-rate>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </div>
            </div>
            <div class="state flex-row-start">
              <span class="state-text">说明：作业表现情况</span>
              <div class="rate-item flex-row-start">
                <el-rate :value="0" disabled :max="3"> </el-rate>不合格
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="1" disabled :max="3" :colors="colors">
                </el-rate
                >合格
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="2" disabled :max="3" :colors="colors">
                </el-rate
                >良好
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="3" disabled :max="3" :colors="colors">
                </el-rate
                >优秀（满分）
              </div>
            </div>
          </div>
          <div class="d-bottom">
            <div class="d-head-title">薄弱知识点</div>
            <template>
              <el-table :data="knowledgeList" height="240" border>
                <el-table-column prop="name" label="知识点"> </el-table-column>
                <el-table-column prop="num" label="涉及题数"> </el-table-column>
                <el-table-column prop="correct_accuracy" label="我的得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.correct_accuracy }}%</span></template
                  >
                </el-table-column>
                <el-table-column prop="avg_num" label="班级平均得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.avg_num }}%</span></template
                  >
                </el-table-column>
                <el-table-column prop="max_accuracy" label="班级最高得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.max_accuracy }}%</span></template
                  >
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { formatDate } from "../../config/mUtils.js";
export default {
  components: {},
  data() {
    return {
      tabList: [{ title: "作业消息" }, { title: "系统消息" }],
      tabActive: 0,
      dialog: { title: "文章标题", status: false },
      dialogInform: { title: "成绩一览", status: false },
      query: {
        page: 1,
        pageSize: 10,
      },
      isNull: true,
      pageTotal: 0,
      systemQuery: {
        page: 0,
        pageSize: 10,
      },
      systemList: [],
      listData: [],
      systemTotal: 1,
      colors: ["#bc4654", "#bc4654", "#bc4654"],
      workKnowledgeCount: 0,
      homeworkIng: {},
      homeworkInfo: [],
      knowledgeList: [],
      workKnowledgeList: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    // 获取班级列表
    getList() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/patriarch/getWorkMessage", this.query)
        .then((result) => {
          this.loading.close();
          this.listData = result.data.list;
          this.pageTotal = result.data.total_count;
          this.isNull = this.listData.length > 0;
        })
        .catch(() => {
          this.loading.close();
        });
    },

    getSystemList() {
      this.onLoading();
      this.getRequest(
        "/wenjiaoopne/kc/patriarch/getSystemMessage",
        this.systemQuery
      )
        .then((result) => {
          this.loading.close();
          this.systemData = result.data.list;
          this.systemTotal = result.data.total_count;
          this.isNull = this.systemData.length > 0;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 切换选项卡触发事件
    onSelectTab(v) {
      if (v == 0) {
        this.getList();
      } else {
        this.getSystemList();
      }
      this.tabActive = v;
    },
    onInfo() {
      this.dialog = {
        status: true,
        title: "渠道通知标题",
      };
    },
    onLearningInfo(v) {
      console.log(v);
      this.onLoading();
      this.getRequest(
        "/wenjiaoopne/kc/patriarch/getHomeworkReport",
        {homework_do_code: v.homework_do_code}
      )
        .then((result) => {
          this.homeworkIng = result.data.homework;
          this.homeworkIng.time = formatDate(this.homeworkIng.quiz_time);
          this.homeworkInfo = result.data.homework_info;
          this.workKnowledgeList = result.data.list;
          this.workKnowledgeCount = result.data.total_count;
          this.knowledgeList = result.data.knowledge_list;
          this.loading.close();
          this.dialogInform.status = true;

        })
        .catch(() => {
          this.loading.close();
        });
      
    },
    onPageChange(v) {
      this.$set(this.query, "page", v);
      this.getList();
    },
    systemPageChange(v) {
      this.$set(this.systemQuery, "page", v);
      this.getSystemList();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.patriarch-user-container .right-container .right-header {
  height: 130px;
  padding-top: 2px;
}
.patriarch-user-container .right-container .sign {
  width: 123px;
  height: 49px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.patriarch-user-container .right-container .sign:first-child {
  margin-right: 10px;
}
.patriarch-user-container .right-container .right-header .active {
  background-image: url("../../assets/images/2.png");
}
.patriarch-user-container .right-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.patriarch-user-container .right-container .num {
  display: inline-block;
  color: #40b8ee;
}

.patriarch-user-container .right-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}
.patriarch-user-container .right-container .right-main {
  background: #f3f6fe;
  /* margin-left: 30px; */
}
.patriarch-user-container .list-box {
  min-height: 415px;
  padding: 5px 15px;
  color: #333;
}

.patriarch-user-container .list-box .item {
  height: 100px;
  background-color: #fff;
  padding: 0 20px;
  margin: 10px 0;
}
.p-inform-container .user-top {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
  background-color: #bcc8dd;
}
.p-inform-container .user-top .user-top-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
}
.patriarch-user-container .list-page {
  padding-top: 10px;
  float: right;
}
.p-inform-container .item-time {
  margin-left: 30px;
  color: #40b8ee;
}
.p-inform-container .item-l-bottom {
  margin-top: 10px;
}
.p-inform-container .em {
  margin-right: 15px;
  font-size: 14px;
}
.p-inform-container .em:last-child {
  margin-right: 0px;
}

.p-inform-container .item-right-text {
  margin-right: 10px;
}
.p-inform-container .item-right-button {
  width: 82px;
}

.p-inform-container .dialog-head div {
  margin: 0 10px;
  color: #999;
}
.p-inform-container .dialog-content {
  height: 400px;
}

.dialog-header .dialog-header-item {
  padding: 10px 0;
  width: 50%;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.dialog-header .dialog-header-item {
  background: #40b8ee;
}
.dialog-header .active {
  background: #bc4654;
}
.books-dialog .dialog-content {
  height: 620px;
}
.books-dialog .dialog-content .dialog-info {
  width: 100%;
  height: 620px;
}
.books-dialog .d-head .d-head-item {
  width: 33%;
  height: 150px;
  margin-top: 10px;
}
.books-dialog .d-head .dashed {
  border-left: 2px dotted #ebf7fe;
  border-right: 2px dotted #ebf7fe;
}
.homework-info-name {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.d-head-box {
  padding: 0 20px;
}
.d-head-title {
  color: #333;
  border-left: 4px solid #bc4654;
  padding-left: 5px;
  font-size: 14px;
  font-weight: 700;
  margin: 10px 0;
}
.d-head-score .score-num {
  font-size: 40px;
  color: #bc4654;
  text-align: center;
  margin: 5px 0;
}
.score-text {
  text-align: center;
}
.d-head-score-item {
  color: #333;
}
.d-head-k {
  padding-top: 10px;
  height: 80px;
  color: #40b8ee;
}
.d-head-k .item {
  display: inline-block;
  padding: 5px 15px 5px 0;
}
.d-center,
.d-bottom {
  padding: 0 20px;
}

.state {
  margin: 10px 0;
  font-size: 12px;
}
.state .rate-item {
  margin: 0 10px;
}
.state-text {
  display: inline-block;
  margin-right: 60px;
}
.dialog-video {
  width: 210px;
  height: 620px;
  background-color: #25292d;
}
.dialog-video-list {
  height: 550px;
}
.dialog-video .v-head-title {
  text-align: center;
  padding: 15px 20px;
  color: #fff;
}
.video-item {
  margin-bottom: 20px;
  cursor: pointer;
}
.video {
  width: 180px;
  height: 110px;
  background-color: #40b8ee;
}
.video img {
  width: 100%;
  height: 100%;
}
.video-title {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f8f9fa;
  padding: 5px 0;
}
</style>
